// import placeholderNav from "./navigations/placeholder";
import detailedEvaluationNav from "./navigations/detailedEvaluation";
import gradingNav from "./navigations/grading";
import finalRecommendationNav from "./navigations/finalRecommendation";
import dashboardNav from "./navigations/dashboard";
import ProposalSummaryNav from "./navigations/proposalSummary";
import ProgressLayout from "../Layouts/Main/progress";
import MainLayout from "../Layouts/Main/main";

export const siteMap = [
  {
    text: "Detailed evaluation",
    route: "/detailedevaluation",
    navigation: detailedEvaluationNav("/detailedevaluation", ProgressLayout),
    progress: true,
  },
  {
    text: "Grading (%)",
    route: "/grading",
    navigation: gradingNav("/grading", ProgressLayout),
    progress: true,
  },
  {
    text: "Final Recommendation",
    route: "/finalrecommendation",
    navigation: finalRecommendationNav("/finalrecommendation", ProgressLayout),
    progress: true,
  },
  {
    text: "Send",
    route: "/proposalSummary",
    navigation: ProposalSummaryNav("/proposalSummary", MainLayout),
    progress: true,
  },
  {
    text: "Dashboard",
    route: "/dashboard",
    navigation: dashboardNav("/dashboard", MainLayout),
    progress: false,
  },
];

const routingOrder = siteMap
  .filter((sm) => sm.progress === true)
  .flatMap((sm) => sm.navigation)
  .flatMap((n) => n.links)
  .map((l) => l.route)
  .filter((r) => r);

export function getPrev(current) {
  if (current[current.length - 1] !== "/") {
    current = `${current}/`;
  }
  if (current === "/detailedevaluation/") return "/";
  const index = routingOrder.indexOf(current);
  if (index === -1) return null;
  if (!routingOrder[index - 1]) return null;
  return routingOrder[index - 1];
}
export function getNext(current) {
  let currentRoute = current;
  if (currentRoute[currentRoute.length - 1] !== "/") {
    currentRoute = `${currentRoute}/`;
  }
  const index = routingOrder.indexOf(currentRoute);
  if (index === -1) return null;
  if (!routingOrder[index + 1]) return null;
  return routingOrder[index + 1];
}
